'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CreditCount = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _verify = require('helpers/verify');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreditCount = exports.CreditCount = function CreditCount(_ref) {
  var creditsRemaining = _ref.creditsRemaining;
  return (0, _verify.isPresent)(creditsRemaining) && _react2.default.createElement(
    'div',
    { className: 'header__credit-count' },
    _react2.default.createElement(
      'a',
      { href: '/settings/membership ' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'nav.mobile.credits',
        defaultMessage: '{creditsRemaining, plural, one {# credit} other {# credits}}',
        values: { creditsRemaining: creditsRemaining }
      })
    )
  );
};

CreditCount.propTypes = {
  creditsRemaining: _propTypes2.default.number
};